import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";


function useGetSensorDetails(id, modalSubmitted) {

    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        fetchData("CC_Sensor", { subject_filter: `id ='${id}'` })
            .then((res) => {
                if (res.objs && res.objs.length > 0) {
                    // console.log(res.objs[0])
                    setData(res.objs[0]);
                } else {
                    setData();
                }
            }).catch((error) => {
                console.error("Error fetching CAN-CUI data:", error);
                toast.error("Error fetching CAN-CUI data. Please try again later.");
                setIsError(true);
            }
            ).finally(() => {
                setIsLoading(false);
            }
            );


    }, [id,modalSubmitted]);

    return {
        data,
        isLoading,
        isError
    };
}
export default useGetSensorDetails;